import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { omit } from 'lodash';
import { ServerDataSource } from 'angular2-smart-table';
import { environment } from '../../../environments/environment';
import { HttpService } from './common/http.service';
import { PayrollPeriod, PayrollPeriodData } from '../interfaces/payroll-period';
import { defaultDataOmitFields, prepRecordForApi } from '../utils/utils.service';

@Injectable()
export class PayrollPeriodService extends PayrollPeriodData {

  private readonly url = 'payroll/periods';

  get gridDataSource(): ServerDataSource {
    return this.api.getServerDataSource(
      `${environment.API_BASE_URL}/${this.url}?sort=startDate:desc`
    );
  }

  constructor(private api: HttpService) {
    super();
  }

  listAll(): Observable<PayrollPeriod[]> {
    return this.api.get(`${this.url}?pagination[pageSize]=500&sort=startDate:desc`).pipe(
      map((res) => res.data ?? res)
    );
  }

  list(pageNumber: number, pageSize: number): Observable<PayrollPeriod[]> {
    let params = new HttpParams().append('sort', 'startDate:desc');
    if (pageSize > 0)   params = params.append('pagination[pageSize]', `${pageSize}`);
    if (pageNumber > 0) params = params.append('pagination[page]', `${pageNumber}`);
    return this.api.get(this.url, { params }).pipe(map((res) => res.data ?? res));
  }

  get(id: string): Observable<PayrollPeriod> {
    return this.api.get(`${this.url}/${id}`).pipe(map((res) => res.data ?? res));
  }

  create(period: Partial<PayrollPeriod>): Observable<PayrollPeriod> {
    const data = prepRecordForApi(omit(period, [...defaultDataOmitFields]));
    return this.api.post(this.url, { data }).pipe(map((res) => res.data ?? res));
  }

  update(period: PayrollPeriod): Observable<PayrollPeriod> {
    const data = prepRecordForApi(omit(period, [...defaultDataOmitFields, 'id', 'documentId', 'createdAt', 'updatedAt']));
    return this.api.put(`${this.url}/${period.documentId}`, { data }).pipe(map((res) => res.data ?? res));
  }

  delete(id: string): Observable<boolean> {
    return this.api.delete(`${this.url}/${id}`).pipe(map(() => true));
  }
}
